module.exports = __webpack_public_path__ + "assets/bf63b87502f6948104b1a0c6d1b56edc.png";